<template>
    <div class="border overflow-hidden cursor-pointer mx-7 bg-white rounded-25" @click="clickMission()">
        <div class="campaign-image" :style="{'background-image': `url('${getCampaignImage(mission.partitionKey)}')`}"></div>
        <div class="pb-3 pt-2 px-16 relative">
            <div class="absolute left-2.5 -top-8"><img class="h-14" :src="getPointImage(mission.partitionKey)" /></div>
            <div class="text-666666 text-22">{{mission.name}}</div>
        </div>
    </div>
</template>
<script>
import LocaleMixin from "@/mixin/LocaleMixin.js";
import ConfigManager from "@/config/ConfigManager.js";

export default {
    name: "CampaignItem",
    mixins: [LocaleMixin],
    props: {
        mission: { type: Object, required: true },
    },
    methods: {
        getPointMessage: function () {
            var pointType = this.campaign.pointType == 'get' ? this.lbl.campaign.get_point : this.lbl.campaign.use_point;
            var pointUnit = this.lbl.campaign.point + (this.campaign.pointPerUnit > 1 && this.localeCode == 1033 ? 's' : '');
            return pointType + " " + this.campaign.pointPerUnit + " " + pointUnit;
        },

        clickMission: function() {
            var path = this.mission.customInfo + "/" + this.mission.partitionKey;
            this.$router.push(path);
        },
        getCampaignImage: function (key) {
            return ConfigManager.getBlobUrl() + "/webconfig/tipcoin/images/badge/" + key + ".png";
        },
        getPointImage: function (key) {
            return ConfigManager.getBlobUrl() + "/webconfig/tipcoin/images/badge/points/" + key + ".png";
        },
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/image.scss";
    .campaign-image {
        @include boxRatio($ratio: 50%);
    }
</style>
